import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Cite } from "@/components/Cite";
import { CheckupCta } from "@/sections/CheckupCta";
import { SoftSkillsGrid } from "@/sections/SoftSkillsGrid";
import { ForWho } from "@/sections/ForWho";
import { Testimonials } from "@/sections/Testimonials";

export const Bento = () => (
  <section id="metodo" data-testid="bento-section" className="px-5 py-24 md:px-10 md:py-32">
    <div className="mx-auto max-w-[1400px]">
      <p className="eyebrow mb-4">L'approccio Hybrid Health Lab</p>
      <div className="mb-12 grid gap-8 md:grid-cols-2 md:items-end">
        <h2 className="max-w-3xl font-display text-6xl font-900 uppercase leading-[0.85] md:text-8xl">
          Lifestyle <span className="text-[#c4dcca]">Training.</span>
        </h2>
        <p className="max-w-xl text-base text-[#f4f7f5] md:justify-self-end md:text-xl">
          Allenare lo stile di vita, non solo il corpo. Perché i risultati non si costruiscono nell'ora di palestra, ma nelle altre 167 ore della settimana.
        </p>
      </div>
      <div className="grid gap-6 text-[#a3b1aa] md:grid-cols-3" data-testid="lifestyle-explainer">
        <p><span className="text-[#f4f7f5]">Cos'è.</span> Il Lifestyle Training è un percorso di ricomposizione corporea che tiene insieme allenamento, nutrizione e recupero con le competenze che li rendono possibili ogni giorno.</p>
        <p><span className="text-[#f4f7f5]">Perché funziona.</span> Il principale predittore dei risultati a lungo termine non è la scheda perfetta, ma la capacità di seguirla nel tempo. E l'aderenza non è una questione tecnica: dipende da abilità mentali che si possono allenare, come la forza.<Cite refs={["teixeira2012", "burke2011"]} /></p>
        <p><span className="text-[#f4f7f5]">Come si allena.</span> Una competenza alla volta, con esercizi pratici da inserire nella settimana. Sono le 9 soft skills che trovi qui sotto.</p>
      </div>
      <SoftSkillsGrid />
      <ForWho />
      <Testimonials />
      <CheckupCta />
      <div className="mt-12 flex justify-center">
        <Link to="/testimonianze" data-testid="lifestyle-testimonials-btn"
          className="group inline-flex items-center gap-3 border border-[#98bfa2] px-8 py-4 font-display text-lg font-800 uppercase text-[#c4dcca] transition-colors hover:bg-[#98bfa2] hover:text-[#050807]">
          Leggi le testimonianze <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  </section>
);
